import { put } from 'redux-saga/effects';

import {
  EditPublishedConnectionDraftReduxAction
} from '~src/publishedConnection/actions/EditPublishedConnectionDraftReduxAction';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';

export function* handleEditPublishedConnectionDraft(action: EditPublishedConnectionDraftReduxAction) {
  try {
    ContentActionsService.editPublishedConnectionDraft(action.draftLuid);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
